/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PolygonCollection } from './PolygonCollection';
import type { TileCollection } from './TileCollection';
import type { ValueObject_Location } from './ValueObject_Location';
export type GeoPolygon = {
    geoId?: string;
    geoType?: GeoPolygon.geoType;
    polygons?: PolygonCollection | null;
    tiles?: TileCollection | null;
    center?: ValueObject_Location | null;
    isUserDefinedLocation?: boolean;
    readonly userDefinedLocation?: boolean;
};
export namespace GeoPolygon {
    export enum geoType {
        CITY = 'city',
        VOIVODESHIP = 'voivodeship',
        REGION = 'region',
        COUNTRY = 'country',
    }
}
